export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Jak otrzymam materiały?',
    answer:
      'Natychmiast. Zaraz po zakupie otrzymujesz dostęp cyfrowy i możesz pobrać wszystkie 6 tomów oraz 5 bonusów.',
  },
  {
    question: 'Czy potrzebuję doświadczenia jako trener?',
    answer:
      'Nie. Każda sesja jest opisana krok po kroku, z punktami nauczania i najczęstszymi błędami, więc poprowadzisz ją nawet bez specjalizacji z siatkówki.',
  },
  {
    question: 'Dla jakiego wieku jest przeznaczony?',
    answer:
      'Program obejmuje zawodników od 6 do 17+ lat — sześć progresywnych tomów, od pierwszego kontaktu z piłką do wysokiego poziomu.',
  },
  {
    question: 'Czy ćwiczenia są ułożone progresywnie?',
    answer:
      'Tak. Każdy tom to kolejny poziom trudności, a wewnątrz ćwiczenia prowadzą od nauki techniki do zastosowania w grze.',
  },
  {
    question: 'W jakim formacie jest? Czy mogę wydrukować?',
    answer: 'To wysokiej jakości pliki PDF — gotowe do druku i do pracy na tablecie, laptopie czy telefonie.',
  },
  {
    question: 'Czy nadaje się na lekcje WF?',
    answer:
      'Tak. Sesje można prowadzić w 45 minut, z ograniczonym sprzętem i dużą grupą — świetnie działają w szkolnej sali.',
  },
  {
    question: 'Czy mogę używać go z całym klubem?',
    answer:
      'Tak. Możesz wykorzystywać materiały we wszystkich swoich grupach treningowych i drukować je na potrzeby własnych zajęć.',
  },
  {
    question: 'Czy jest gwarancja zwrotu?',
    answer:
      'Tak. Masz 30-dniową gwarancję zwrotu pieniędzy. Jeśli program Ci nie odpowiada, napisz do nas i otrzymasz pełny zwrot, a bonusy zostają u Ciebie.',
  },
]
